import auData from './au.data.json'
import { CellData, Group, GroupCell, GroupItem } from './layout'

export default function AuPackage() {
  return (
    <>
      <Group
        title='HouGarden Features'
        titleBgColor='#00A6FF'
        items={[
          <GroupItem
            key={1}
            items={auData[0][0].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='even:bg-[#20A4F8]/5'
              />
            ))}
          />,
          <GroupItem
            key={2}
            items={auData[1][0].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='even:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FAFAFA]'
          />,
          <GroupItem
            key={3}
            items={auData[2][0].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='even:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FBFDFF]'
          />,
          <GroupItem
            key={4}
            items={auData[3][0].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='even:bg-[#20A4F8]/3'
              />
            ))}
            className='bg-[#F0FAFF]'
          />,
        ]}
      />
      <Group
        title='Social Media'
        titleBgColor='#0084FF'
        items={[
          <GroupItem
            key={1}
            items={auData[0][1].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#20A4F8]/5 even:bg-white'
              />
            ))}
          />,
          <GroupItem
            key={2}
            items={auData[1][1].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FAFAFA]'
          />,
          <GroupItem
            key={3}
            items={auData[2][1].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FBFDFF]'
          />,
          <GroupItem
            key={4}
            items={auData[3][1].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#20A4F8]/3'
              />
            ))}
            className='bg-[#F0FAFF]'
          />,
        ]}
      />
      <Group
        title='Extra'
        titleBgColor='#0060B8'
        items={[
          <GroupItem
            key={1}
            items={auData[0][2].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#20A4F8]/5 even:bg-white'
              />
            ))}
          />,
          <GroupItem
            key={2}
            items={auData[1][2].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FAFAFA]'
          />,
          <GroupItem
            key={3}
            items={auData[2][2].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#E1E8ED]/30'
              />
            ))}
            className='bg-[#FBFDFF]'
          />,
          <GroupItem
            key={4}
            items={auData[3][2].data.map((item, index) => (
              <GroupCell
                key={index}
                data={item as CellData}
                className='odd:bg-[#20A4F8]/3'
              />
            ))}
            className='bg-[#F0FAFF]'
          />,
        ]}
      />
    </>
  )
}
